export default __webpack_public_path__ + "static/media/disabled-new-icon.2ef83ad4.svg";